import { NumberInputBase, NumberInputBaseProps } from './NumberInputBase';
import { useNumberInputLocalePreset } from './use-number-input-locale-preset';

export interface NumberInputProps extends NumberInputBaseProps {
  locale?: string;
}

export function NumberInput(props: NumberInputProps) {
  const { locale, ...otherProps } = props;

  const localeProps = useNumberInputLocalePreset(locale);

  return <NumberInputBase {...localeProps} {...otherProps} />;
}
